// a szálak (jegy, portál) kártya-tónusai — külön modulban, hogy a komponens-fájlok csak komponenst exportáljanak

/**
 * A „MI" oldali bejegyzés kártya-tónusa (halvány brand) — a portálon a saját bejegyzés, a belső jegy-szálon a
 * munkatárs kommentje (Évi #84) hordozza; egy helyen, hogy a két felület ugyanazt a jelet adja.
 */
export const THREAD_TONE_OURS = 'border-brand/25 bg-brand-soft/50';
